import { render, staticRenderFns } from "./loadBtn.vue?vue&type=template&id=745c0b62"
import script from "./loadBtn.vue?vue&type=script&lang=js"
export * from "./loadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports